import React, { Fragment } from "react";

import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { blueGrey } from "@material-ui/core/colors";

import { useTealium } from "@hubcapp/context";
import Button from "@ds-developer/button";

import { AreaProps } from "./types";

const useStyles = makeStyles(theme => ({
  cardHeader: {
    color: blueGrey["600"],
  },
  contentContainer: {
    padding: theme.spacing(3, 2),
  },
  actionContainer: {
    padding: theme.spacing(2),
    justifyContent: "flex-end",
  },
  buttonContainer: {
    textAlign: "right",
  },
}));

const Area: React.FC<AreaProps> = ({
  avatar,
  children,
  editable = false,
  onClick = () => {},
  showButton = true,
  title,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { trackEvent } = useTealium();

  const handleButtonClickEvent = () => {
    trackEvent({
      eventCategory: "Areas & prices",
      eventAction: "Button Click",
      eventLabel: editable ? "Edit" : "View",
    });
    onClick();
  };

  return (
    <Card data-test="area-card">
      {title && (
        <Fragment>
          <CardHeader
            title={<Typography variant="h2">{title}</Typography>}
            classes={{ root: classes.cardHeader }}
          />
          <Divider />
        </Fragment>
      )}
      <CardContent className={classes.contentContainer}>
        <Grid
          container
          alignItems="center"
          direction="row"
          justify="space-between"
          spacing={2}
        >
          {avatar}
          {children}
          {showButton && !isMobile && (
            <Grid item xs={1} className={classes.buttonContainer}>
              <Button
                color="secondary"
                data-test="area-card-button"
                onClick={() => {
                  handleButtonClickEvent();
                }}
                variant="contained"
              >
                {editable ? "Edit" : "View"}
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
      {showButton && isMobile && (
        <Fragment>
          <Divider />
          <CardActions className={classes.actionContainer}>
            <Button
              color="secondary"
              data-test="area-card-button"
              onClick={() => {
                handleButtonClickEvent();
              }}
              variant="contained"
            >
              {editable ? "Edit" : "View"}
            </Button>
          </CardActions>
        </Fragment>
      )}
    </Card>
  );
};

export default Area;
